import type { ReactNode } from 'react'
import type { ProductFeature } from '@tfa/shared'
import { useTelegram } from '../hooks/useTelegram'
import { lockText, LOCK_CTA, SALES_URL } from '../utils/featureLocks'

const F = 'Roboto, sans-serif'

/**
 * Раздел под замком (три тарифа, этап 2): настоящий экран под размытием,
 * поверх — иконка, заголовок и кнопка «Получить доступ к полному функционалу»
 * в отдел продаж. ТЗ: «не просто замочек, а замочек и надпись, и ссылка».
 *
 * С children оборачивает страницу; без — полноэкранный слой (для ИИ-Павла,
 * который открывается шторкой, а не маршрутом).
 */
export function LockedFeature({ feature, children, onClose }: { feature: ProductFeature; children?: ReactNode; onClose?: () => void }) {
  const { openLink, impactHaptic } = useTelegram()
  const t = lockText(feature)
  const fullscreen = children == null
  return (
    <div
      data-testid={`locked-feature-${feature}`}
      style={fullscreen
        ? { position: 'fixed', inset: 0, zIndex: 290, background: 'rgba(240,244,248,0.72)', backdropFilter: 'blur(14px)', WebkitBackdropFilter: 'blur(14px)' }
        : { position: 'relative', minHeight: '60vh' }}
    >
      {!fullscreen && (
        <div aria-hidden style={{ filter: 'blur(6px)', pointerEvents: 'none', userSelect: 'none', opacity: 0.75 }}>
          {children}
        </div>
      )}
      <div
        style={{
          position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '24px 20px', paddingBottom: 110, zIndex: 2,
        }}
      >
        <div
          style={{
            width: '100%', maxWidth: 340, borderRadius: 24, padding: '22px 20px', textAlign: 'center', fontFamily: F,
            background: 'rgba(255,255,255,0.92)', boxShadow: '0 10px 30px rgba(26,58,92,0.18)', border: '1px solid rgba(255,255,255,0.7)',
          }}
        >
          <div style={{ fontSize: 40, lineHeight: 1 }} aria-hidden>{t.icon}</div>
          <div style={{ marginTop: 10, fontSize: 17, fontWeight: 800, color: '#1A3A5C', lineHeight: 1.25 }}>{t.title}</div>
          {t.subtitle && <div style={{ marginTop: 6, fontSize: 13, color: '#6B7A90', lineHeight: 1.4 }}>{t.subtitle}</div>}
          <button
            type="button"
            data-testid="locked-feature-cta"
            onClick={() => { impactHaptic('medium'); openLink(SALES_URL) }}
            style={{
              marginTop: 16, width: '100%', height: 46, borderRadius: 14, border: 'none', cursor: 'pointer',
              background: 'linear-gradient(135deg,#6C5CE7,#A29BFE)', color: 'white', fontSize: 14, fontWeight: 700, fontFamily: F,
              boxShadow: '0 6px 18px rgba(108,92,231,0.35)',
            }}
          >
            🔒 {LOCK_CTA}
          </button>
          {onClose && (
            <button type="button" data-testid="locked-feature-close" onClick={onClose} style={{ marginTop: 10, background: 'transparent', border: 'none', color: '#6B7A90', fontSize: 13, cursor: 'pointer', fontFamily: F }}>
              Закрыть
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
